import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { Providers } from './components/Providers';
import { ThemeToggle } from './components/app/ThemeToggle';
import './i18n/config';
import './styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <App />
      <div className="group fixed bottom-0 left-1/2 z-50 mb-2 -translate-x-1/2">
        <ThemeToggle className="translate-y-20 transition-transform delay-150 duration-300 group-hover:translate-y-0" />
      </div>
    </Providers>
  </React.StrictMode>
);
